module.exports = __webpack_public_path__ + "img/ticketFooter.609419b0.svg";